import { render, staticRenderFns } from "./activityScoreEntry.vue?vue&type=template&id=31ccc013&scoped=true"
import script from "./activityScoreEntry.vue?vue&type=script&lang=js"
export * from "./activityScoreEntry.vue?vue&type=script&lang=js"
import style0 from "./activityScoreEntry.vue?vue&type=style&index=0&id=31ccc013&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ccc013",
  null
  
)

export default component.exports